module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-1-c3c9953f644b028c6381dade930dcb61.svg";